module.exports = __webpack_public_path__ + "2348f601019dcaddec29e8ada331fe56.svg";